import { Route, Navigate, Outlet, useParams } from "react-router";
import { MainLayout } from "./MainLayout";
import { SynthesisLayout } from "./Tabs/1_TabTrajectories/SynthesisLayout";
import { TrajectoriesBarChart } from "./Tabs/1_TabTrajectories/Trajectory/TrajectoriesBarChart";
import { SynthesisCards } from "./Tabs/1_TabTrajectories/Synthesis/SynthesisCards";
import { OneInLocalStorage } from "src/services/OneFromLocalStorage";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { ActionPlanInit } from "./NoActionPlan/ActionPlanInit";
import { ActionPlanLayout } from "./Tabs/2_TabActionPlan/ActionPlanLayout";
import { ListPlanning } from "./Tabs/2_TabActionPlan/ActionList/List/ListPlanning";
import { EditPlanningProperties } from "./Tabs/2_TabActionPlan/EditProperties/EditPlanningProperties";
import { CatalogLayout } from "./Tabs/3_TabCatalog/CatalogLayout";
import { CatalogSummary } from "./Tabs/3_TabCatalog/Summary/List/CatalogSummary";
import { CatalogProvider } from "./Tabs/3_TabCatalog/Summary/context/provider";
import { SubgroupList } from "./Tabs/3_TabCatalog/Summary/Subgroup/SubgroupList";
import { CatalogItemLayout } from "./Tabs/3_TabCatalog/CatalogItem/CatalogItemLayout";
import { CatalogItemDetail } from "./Tabs/3_TabCatalog/CatalogItem/CatalogItemDetail";
import { MyActionPlanProvider } from "./Tabs/2_TabActionPlan/context/provider";

const noActionPlayKey = "noActionPlan" as const;

export const useActionPlanRouter = () => {
    return (
        <Route path="actions">
            <Route index element={<GlobalActionRedirect />} />
            <Route path={noActionPlayKey} element={<MainLayout />}>
                <Route index element={<ActionPlanInit />} />
            </Route>
            <Route path="trajectory" element={<MainLayout selectedSection="trajectory" />}>
                <Route index element={<TrajectoryRedirect />} />
                <Route path="barChart" element={<SynthesisLayout selectedButton="barChart" />}>
                    <Route index element={<TrajectoriesBarChart />} />
                </Route>
                <Route path="cards" element={<SynthesisLayout selectedButton="cards" />}>
                    <Route index element={<SynthesisCards />} />
                </Route>
            </Route>

            <Route path="planning" element={<MainLayout selectedSection="planning" />}>
                {/* To decomission someday. Used for breaking change in URLs */}
                <Route path="list" element={<PlanningRedirect />} />
                <Route element={<ActionPlanLayout />}>
                    <Route index element={<ListPlanning />} />

                    <Route element={<MyActionPlanContext />}>
                        <Route path=":actionPlanActionId" element={<EditPlanningProperties />} />
                    </Route>
                </Route>
            </Route>

            <Route path="catalog" element={<MainLayout selectedSection="catalog" />}>
                <Route element={<RouterCatalogContext />}>
                    <Route element={<CatalogLayout />}>
                        <Route index element={<CatalogSummary />} />
                        <Route path={":groupId"} element={<SubgroupList />} />
                    </Route>
                    <Route path={":groupId"} element={<CatalogItemLayout />}>
                        <Route path="action/:actionId">
                            <Route index element={<CatalogItemDetail />} />
                        </Route>
                    </Route>
                </Route>
            </Route>
        </Route>
    );
};

const MyActionPlanContext = () => {
    const { actionPlanActionId } = useParams();

    return (
        <MyActionPlanProvider actionPlanActionId={actionPlanActionId}>
            <Outlet />
        </MyActionPlanProvider>
    );
};

const RouterCatalogContext = () => {
    const { groupId } = useParams();
    const { actionId } = useParams();

    return (
        <CatalogProvider groupId={groupId} actionId={actionId}>
            <Outlet />
        </CatalogProvider>
    );
};

const GlobalActionRedirect = () => {
    const { actionPlan } = useActionsContext();

    if (actionPlan === null) {
        return <Navigate to={noActionPlayKey} replace />;
    }
    const existingMainTab = OneInLocalStorage.getItem("actionPlan-main-tabs");
    return <Navigate to={existingMainTab} replace />;
};

const PlanningRedirect = () => {
    const { urls } = useActionsContext();

    const url = urls.planning();

    // const existingPlanningTab = OneInLocalStorage.getItem("actionPlan-planning-tabs");
    return <Navigate to={url} replace />;
};

const CatalogRedirect = () => {
    const existingCatalogTab = OneInLocalStorage.getItem("actionPlan-catalog-tabs");
    return <Navigate to={existingCatalogTab} replace />;
};

const TrajectoryRedirect = () => {
    const existingTrajectoryTab = OneInLocalStorage.getItem("actionPlan-trajectory-tabs");
    return <Navigate to={existingTrajectoryTab} replace />;
};
